/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LpInspectionResultDto } from '../../models/lp-inspection-result-dto';
import { OffsetPaginationDto } from '../../models/offset-pagination-dto';

export interface LpInspectionResultControllerSearchOffset$Params {

/**
 * 페이지 크기
 */
  pageSize: number;

/**
 * 정렬 기준
 */
  orderBy?: string;

/**
 * 정렬 방향
 */
  align?: 'asc' | 'desc';

/**
 * 검색어
 */
  query?: string;

/**
 * 페이지 번호
 */
  pageNo: number;

/**
 * inspection ID
 */
  inspectionId?: string | null;

/**
 * valid
 */
  valid?: string | null;
}

export function lpInspectionResultControllerSearchOffset(http: HttpClient, rootUrl: string, params: LpInspectionResultControllerSearchOffset$Params, context?: HttpContext): Observable<StrictHttpResponse<OffsetPaginationDto & {
'items'?: Array<LpInspectionResultDto>;
}>> {
  const rb = new RequestBuilder(rootUrl, lpInspectionResultControllerSearchOffset.PATH, 'get');
  if (params) {
    rb.query('pageSize', params.pageSize, {});
    rb.query('orderBy', params.orderBy, {});
    rb.query('align', params.align, {});
    rb.query('query', params.query, {});
    rb.query('pageNo', params.pageNo, {});
    rb.query('inspectionId', params.inspectionId, {});
    rb.query('valid', params.valid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<OffsetPaginationDto & {
      'items'?: Array<LpInspectionResultDto>;
      }>;
    })
  );
}

lpInspectionResultControllerSearchOffset.PATH = '/api/lp-inspection-result/search/offset';
